import { getAffiliateInfo, getUser } from '../selectors/users';

import { useAppSelector } from './redux';

export const useUser = () => useAppSelector(getUser);
export const useAffiliateInfo = () => useAppSelector(getAffiliateInfo);
